// extracted by mini-css-extract-plugin
export var downArrow = "_9c-0";
export var infoTooltipIcon = "_9c-3";
export var label = "_9c-1";
export var optionCard = "_9c-4";
export var upArrow = "_9c-2";